<template>
  <b-container>
    <b-card class="cardStyle">
      <b-card-title class="cardTitle">
        {{ topic.title }}
      </b-card-title>
      <hr class="solid my-4" />
      <p class="cardContent"><span v-html="topic.body"></span></p>
    </b-card>
  </b-container>
</template>

<script>
  export default {
    props: {
      topic: {
        type: Object,
      },
    },
  };
</script>

<style scoped>
  .cardStyle {
    background: #fffbfe;
    border-radius: 8px;
    margin-top: 2rem;
  }
  .cardTitle {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #00004e;
  }
  .cardContent {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
  }
</style>
